import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GATrackingEventType } from '../../constants';

export class GaTrackingSearch_0_resultsEventModel implements GATrackingEvent {
  constructor(private payload: { action: GATrackingEventType }) {}

  getEventActionFromPage(): any {
    return `${this.payload.action} visible`;
  }

  getEventType(): GATrackingEventType {
    return this.getEventActionFromPage();
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: 'search_0_results',
    };
  }
}
